import sema1 from '../../assets/photos/sebi-arus/sema-1.jpg';
import sema2 from '../../assets/photos/sebi-arus/sema-2.jpg';

import sema12022 from '../../assets/photos/sebi-arus/2022/sema-1-2022.jpg';
import sema22022 from '../../assets/photos/sebi-arus/2022/sema-2-2022.jpg';
import sema32022 from '../../assets/photos/sebi-arus/2022/sema-3-2022.jpg';
import sema42022 from '../../assets/photos/sebi-arus/2022/sema-4-2022.jpg';
import sema52022 from '../../assets/photos/sebi-arus/2022/sema-5-2022.jpg';
import sema62022 from '../../assets/photos/sebi-arus/2022/sema-6-2022.jpg';
import sema72022 from '../../assets/photos/sebi-arus/2022/sema-7-2022.jpg';
import sema82022 from '../../assets/photos/sebi-arus/2022/sema-8-2022.jpg';
import sema92022 from '../../assets/photos/sebi-arus/2022/sema-9-2022.jpg';
import sema102022 from '../../assets/photos/sebi-arus/2022/sema-10-2022.jpg';
import sema112022 from '../../assets/photos/sebi-arus/2022/sema-11-2022.jpg';
import sema122022 from '../../assets/photos/sebi-arus/2022/sema-12-2022.jpg';
import sema132022 from '../../assets/photos/sebi-arus/2022/sema-13-2022.jpg';
import sema142022 from '../../assets/photos/sebi-arus/2022/sema-14-2022.jpg';
import sema152022 from '../../assets/photos/sebi-arus/2022/sema-15-2022.jpg';
import sema162022 from '../../assets/photos/sebi-arus/2022/sema-16-2022.jpg';
import sema172022 from '../../assets/photos/sebi-arus/2022/sema-17-2022.jpg';

import sema1Mini2022 from '../../assets/photos/sebi-arus/2022/sema-1-mini-2022.jpg';
import sema2Mini2022 from '../../assets/photos/sebi-arus/2022/sema-2-mini-2022.jpg';
import sema3Mini2022 from '../../assets/photos/sebi-arus/2022/sema-3-mini-2022.jpg';
import sema4Mini2022 from '../../assets/photos/sebi-arus/2022/sema-4-mini-2022.jpg';
import sema5Mini2022 from '../../assets/photos/sebi-arus/2022/sema-5-mini-2022.jpg';
import sema6Mini2022 from '../../assets/photos/sebi-arus/2022/sema-6-mini-2022.jpg';
import sema7Mini2022 from '../../assets/photos/sebi-arus/2022/sema-7-mini-2022.jpg';
import sema8Mini2022 from '../../assets/photos/sebi-arus/2022/sema-8-mini-2022.jpg';
import sema9Mini2022 from '../../assets/photos/sebi-arus/2022/sema-9-mini-2022.jpg';
import sema10Mini2022 from '../../assets/photos/sebi-arus/2022/sema-10-2022.jpg';
import sema11Mini2022 from '../../assets/photos/sebi-arus/2022/sema-11-2022.jpg';
import sema12Mini2022 from '../../assets/photos/sebi-arus/2022/sema-12-2022.jpg';
import sema13Mini2022 from '../../assets/photos/sebi-arus/2022/sema-13-2022.jpg';
import sema14Mini2022 from '../../assets/photos/sebi-arus/2022/sema-14-2022.jpg';
import sema15Mini2022 from '../../assets/photos/sebi-arus/2022/sema-15-2022.jpg';
import sema16Mini2022 from '../../assets/photos/sebi-arus/2022/sema-16-2022.jpg';
import sema17Mini2022 from '../../assets/photos/sebi-arus/2022/sema-17-2022.jpg';

import sema12023 from '../../assets/photos/sebi-arus/2023/large/sema-1-2023.jpg';
import sema22023 from '../../assets/photos/sebi-arus/2023/large/sema-2-2023.jpg';
import sema32023 from '../../assets/photos/sebi-arus/2023/large/sema-3-2023.jpg';
import sema42023 from '../../assets/photos/sebi-arus/2023/large/sema-4-2023.jpg';
import sema52023 from '../../assets/photos/sebi-arus/2023/large/sema-5-2023.jpg';
import sema62023 from '../../assets/photos/sebi-arus/2023/large/sema-6-2023.jpg';
import sema72023 from '../../assets/photos/sebi-arus/2023/large/sema-7-2023.jpg';
import sema82023 from '../../assets/photos/sebi-arus/2023/large/sema-8-2023.jpg';
import sema92023 from '../../assets/photos/sebi-arus/2023/large/sema-9-2023.jpg';
import sema102023 from '../../assets/photos/sebi-arus/2023/large/sema-10-2023.jpg';
import sema112023 from '../../assets/photos/sebi-arus/2023/large/sema-11-2023.jpg';
import sema122023 from '../../assets/photos/sebi-arus/2023/large/sema-12-2023.jpg';
import sema132023 from '../../assets/photos/sebi-arus/2023/large/sema-13-2023.jpg';
import sema142023 from '../../assets/photos/sebi-arus/2023/large/sema-14-2023.jpg';
import sema152023 from '../../assets/photos/sebi-arus/2023/large/sema-15-2023.jpg';
import sema162023 from '../../assets/photos/sebi-arus/2023/large/sema-16-2023.jpg';
import sema172023 from '../../assets/photos/sebi-arus/2023/large/sema-17-2023.jpg';
import sema182023 from '../../assets/photos/sebi-arus/2023/large/sema-18-2023.jpg';
import sema192023 from '../../assets/photos/sebi-arus/2023/large/sema-19-2023.jpg';
import sema202023 from '../../assets/photos/sebi-arus/2023/large/sema-20-2023.jpg';
import sema212023 from '../../assets/photos/sebi-arus/2023/large/sema-21-2023.jpg';
import sema222023 from '../../assets/photos/sebi-arus/2023/large/sema-22-2023.jpg';
import sema232023 from '../../assets/photos/sebi-arus/2023/large/sema-23-2023.jpg';

import sema1Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-1-mini-2023.jpg';
import sema2Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-2-mini-2023.jpg';
import sema3Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-3-mini-2023.jpg';
import sema4Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-4-mini-2023.jpg';
import sema5Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-5-mini-2023.jpg';
import sema6Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-6-mini-2023.jpg';
import sema7Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-7-mini-2023.jpg';
import sema8Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-8-mini-2023.jpg';
import sema9Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-9-mini-2023.jpg';
import sema10Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-10-mini-2023.jpg';
import sema11Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-11-mini-2023.jpg';
import sema12Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-12-mini-2023.jpg';
import sema13Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-13-mini-2023.jpg';
import sema14Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-14-mini-2023.jpg';
import sema15Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-15-mini-2023.jpg';
import sema16Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-16-mini-2023.jpg';
import sema17Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-17-mini-2023.jpg';
import sema18Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-18-mini-2023.jpg';
import sema19Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-19-mini-2023.jpg';
import sema20Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-20-mini-2023.jpg';
import sema21Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-21-mini-2023.jpg';
import sema22Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-22-mini-2023.jpg';
import sema23Mini2023 from '../../assets/photos/sebi-arus/2023/mini/sema-23-mini-2023.jpg';

export interface ImageType {
    src: string;
}
export const Images2018: ImageType[] = [
    { src: sema1 },
    { src: sema2 }
]

export const SebiArusLargeImg2022: ImageType[] = [
    { src: sema12022 },
    { src: sema22022 },
    { src: sema32022 },
    { src: sema42022 },
    { src: sema52022 },
    { src: sema62022 },
    { src: sema72022 },
    { src: sema82022 },
    { src: sema92022 },
    { src: sema102022 },
    { src: sema112022 },
    { src: sema122022 },
    { src: sema132022 },
    { src: sema142022 },
    { src: sema152022 },
    { src: sema162022 },
    { src: sema172022 },
]

export const SebiArusMiniImg2022: ImageType[] = [
    { src: sema1Mini2022 },
    { src: sema2Mini2022 },
    { src: sema3Mini2022 },
    { src: sema4Mini2022 },
    { src: sema5Mini2022 },
    { src: sema6Mini2022 },
    { src: sema7Mini2022 },
    { src: sema8Mini2022 },
    { src: sema9Mini2022 },
    { src: sema10Mini2022 },
    { src: sema11Mini2022 },
    { src: sema12Mini2022 },
    { src: sema13Mini2022 },
    { src: sema14Mini2022 },
    { src: sema15Mini2022 },
    { src: sema16Mini2022 },
    { src: sema17Mini2022 },
]
export const SebiArusLargeImg2023: ImageType[] = [
    { src: sema12023 },
    { src: sema22023 },
    { src: sema32023 },
    { src: sema42023 },
    { src: sema52023 },
    { src: sema62023 },
    { src: sema72023 },
    { src: sema82023 },
    { src: sema92023 },
    { src: sema102023 },
    { src: sema112023 },
    { src: sema122023 },
    { src: sema132023 },
    { src: sema142023 },
    { src: sema152023 },
    { src: sema162023 },
    { src: sema172023 },
    { src: sema182023 },
    { src: sema192023 },
    { src: sema202023 },
    { src: sema212023 },
    { src: sema222023 },
    { src: sema232023 }
]

export const SebiArusMiniImg2023: ImageType[] = [
    { src: sema1Mini2023 },
    { src: sema2Mini2023 },
    { src: sema3Mini2023 },
    { src: sema4Mini2023 },
    { src: sema5Mini2023 },
    { src: sema6Mini2023 },
    { src: sema7Mini2023 },
    { src: sema8Mini2023 },
    { src: sema9Mini2023 },
    { src: sema10Mini2023 },
    { src: sema11Mini2023 },
    { src: sema12Mini2023 },
    { src: sema13Mini2023 },
    { src: sema14Mini2023 },
    { src: sema15Mini2023 },
    { src: sema16Mini2023 },
    { src: sema17Mini2023 },
    { src: sema18Mini2023 },
    { src: sema19Mini2023 },
    { src: sema20Mini2023 },
    { src: sema21Mini2023 },
    { src: sema22Mini2023 },
    { src: sema23Mini2023 }
]